export const getNormalizedVideoLink = (url: string) => {
  try {
    const parsed = new URL(url);
    if (
      parsed.hostname.includes("facebook.com") &&
      parsed.href.includes("/watch")
    ) {
      const videoId = parsed.searchParams.get("v");

      if (videoId) {
        return `https://www.facebook.com/facebook/videos/${videoId}/`;
      }
    }

    return url;
  } catch {
    return url;
  }
};
